// extracted by mini-css-extract-plugin
module.exports = {"select-input":"styles_select-input__2y4qK","selectInput":"styles_select-input__2y4qK","disabled":"styles_disabled__37OY1","select":"styles_select__1a7aA"};